import { client } from '@/client';

export function doBuried({ eventId, eventType = 'click', pageUrl = location.href }) {
  return client.put('/api/buried', {
    eventId,
    eventType,
    pageUrl,
  });
}
